// G-Atlas Configuration
import { WEBSERVER_API_ORIGIN } from '../../../config/apiOrigins';

const gAtlasConfig = {
  api: {
    baseUrl: WEBSERVER_API_ORIGIN,
    endpoints: {
      health: '/api/atlas/health',
      atlasSummary: '/api/atlas/summary',
      atlasVariants: '/api/atlas/variants',
      atlasCandidates: '/api/atlas/candidates',
      atlasMechanisms: '/api/atlas/mechanisms',
      atlasNetwork: '/api/atlas/network',
      atlasChatHistory: '/api/atlas/chat/history',
      atlasChatMessage: '/api/atlas/chat/message',
      atlasChatClear: '/api/atlas/chat/history',
      atlasGene: '/api/atlas/gene',
      atlasLocus: '/api/atlas/locus',
      atlasVariant: '/api/atlas/variant',
      atlasPathwaysTop: '/api/atlas/pathways/top',
      atlasSearch: '/api/atlas/search',
    }
  }
};

export function getApiBaseUrl() {
  return gAtlasConfig.api.baseUrl;
}

export function getApiEndpoint(endpoint) {
  const baseUrl = gAtlasConfig.api.baseUrl;
  const path = gAtlasConfig.api.endpoints[endpoint];
  if (!path) {
    throw new Error(`G-Atlas API endpoint "${endpoint}" is not configured`);
  }
  return `${baseUrl}${path}`;
}

export default gAtlasConfig;
